<template>
    <!-- bt wording -->
    <oss-dialog
        v-model="dialog"
        title="Modifier le libellé"
        validTitle="Confirmer les modifications"
        @valid="update()"
        @close="cancelChangingName()"
        :validLoading="changeWordingLoading"
        min-width="70vw"
    >
        <!-- <div class="h2">Choisissez le type de transaction</div> -->
        <v-row no-gutters>
            <v-col cols="12 mb-4">
                <oss-date-picker-filled
                    v-model="date"
                    :filterWithoutClosedAccountingPeriods="!readOnly"
                    :label="$t('shared.debitDate')"
                    :textFieldReadOnly="readOnly"
                    :readOnly="readOnly"
                />
            </v-col>
            <v-col cols="12 mb-4">
                <v-text-field-filled v-model="wording" label="Libellé" :readOnly="readOnly" />
            </v-col>
            <v-col cols="12 mb-4">
                <v-text-field-filled
                    label="Libellé court"
                    readonly
                    :model-value="bankTransaction.wordingLight"
                />
            </v-col>
            <v-col cols="12" class="d-flex justify-end">
                <v-btn-icon
                    class="mr-1"
                    v-if="!displayActivity"
                    @click="displayActivity = true"
                    size="small"
                    icon="$oss-activity"
                />
                <v-btn-icon
                    v-if="displayActivity"
                    class="mr-1 rounded"
                    @click="displayActivity = false"
                    size="small"
                    icon="$oss-close"
                />
                <v-btn
                    class="mr-1"
                    :disabled="!isInAccountingFirm && !isBusinessClient"
                    @click="openWordingAnalysisEdition"
                >
                    Analyse de libellés
                </v-btn>
                <v-btn color="error" class="mr-1" @click="correctBT" v-if="toCorrect">
                    Corriger
                </v-btn>
            </v-col>
        </v-row>
        <template v-if="displayActivity">
            <UsersActivitiesHistory :bankTransactionId="bankTransaction.id">
            </UsersActivitiesHistory>
        </template>
    </oss-dialog>
</template>

<script lang="ts">
import UsersActivitiesHistory from "./UsersActivitiesHistory.vue";
import base64url from "base64url";
import UPDATE_WORDING from "../graphql/bankTransaction/UpdateBankTransactionWording.gql";
import UPDATE_DATEDEBIT from "../graphql/bankTransaction/UpdateBankTransactionDateDebit.gql";
import CORRECT_BANKTRANSACTION from "../graphql/bankTransaction/CorrectBankTransaction.gql";
import { getDBFormattedDate } from "../services/dateServices";
import { Component, Vue, toNative, Prop, Model, Watch } from "vue-facing-decorator";
import { isInsideClosedAccountingPeriod } from "@/services/accountingPeriods";

@Component({
    components: {
        UsersActivitiesHistory,
    },
    emits: ["cancel", "updated"],
})
export class BankTransactionEdition extends Vue {
    @Model() value!: boolean;

    @Prop() bankTransaction; //bankTransaction
    @Prop({ default: "" }) companyId: string; // companyId

    displayActivity: boolean = false;

    date = "";
    wording = "";

    get dialog() {
        return this.value;
    }

    set dialog(event) {
        this.value = event;
    }

    get toCorrect() {
        // return true
        if (!this.bankTransaction) return false;
        if (!this.bankTransaction.accountingLines) return false;
        if (!this.bankTransaction.accountingLines.length) return true;
        return false;
    }

    get isInAccountingFirm() {
        return this.$store.state?.user?.isInAccountingFirm;
    }

    get isBusinessClient() {
        return this.$store.state?.user?.isBusinessClient;
    }

    cancelChangingName() {
        this.$emit("cancel");
    }

    @Watch("bankTransaction")
    onBankTransactionChanged() {
        if (this.bankTransaction) {
            this.date = this.bankTransaction.dateDebit;
            //debugger
            this.wording =
                this.bankTransaction.wordingDisplay || this.bankTransaction.wordingOriginal;
        } else {
            this.date = "";
            this.wording = "";
        }
    }

    beforeMount() {
        this.onBankTransactionChanged();
    }

    changeWordingLoading = false;

    cancelChangingWordingName() {
        this.changeWordingLoading = false;
    }

    async update() {
        if (this.bankTransaction) {
            this.changeWordingLoading = true;
            let refresh = false;
            // debugger
            if (this.bankTransaction.wordingDisplay !== this.wording) {
                await this.$apollo.mutate({
                    mutation: UPDATE_WORDING,
                    variables: {
                        id: this.bankTransaction.id,
                        wording: this.wording,
                    },
                });
                refresh = true;
            }
            if (this.date !== this.bankTransaction.dateDebit) {
                await this.$apollo.mutate({
                    mutation: UPDATE_DATEDEBIT,
                    variables: {
                        id: this.bankTransaction.id,
                        dateDebit: getDBFormattedDate(this.date),
                    },
                });
                refresh = true;
            }
            if (refresh) {
                this.$emit("updated");
            }
            this.changeWordingLoading = false;
            this.dialog = false;
        }
    }

    correctLoading: boolean = false;

    async correctBT() {
        this.correctLoading = true;
        await this.$apollo.mutate({
            mutation: CORRECT_BANKTRANSACTION,
            variables: {
                id: this.bankTransaction.id,
            },
        });
        this.correctLoading = false;
    }

    openWordingAnalysisEdition() {
        if (this.bankTransaction && this.companyId) {
            // const bbt = base64url(JSON.stringify(this.bankTransaction));
            this.$router.push({
                name: "wording-analysis-edition-client-side-new",
                query: {
                    bankTransaction_64: base64url(JSON.stringify(this.bankTransaction)),
                    companyId: this.companyId,
                },
            });
        }
    }

    get readOnly() {
        if (isInsideClosedAccountingPeriod(this.$store, this.date)) {
            return true;
        }
        return false;
    }
}

export default toNative(BankTransactionEdition);
</script>
